<template>
    <div>
        <c-search-form :input-search-items="searchItems" :rows-per-page-items="[10,20,50]"
                       :input-create-items="createItems"
                       :form-name="formName"
                       :fields="fields" accept-copy
                       :search-div="searchDiv"
                       :create-div="createDiv"
                       key-property="fileId"
                       search-url="/files/search"
                       create-url="/files/save"
                       delete-url="/files/delete"
                       form-type="intable"
                       @onOpenRequestInFile="onOpenRequestInFile"
                       @onOpenWaitingRequest="onOpenWaitingRequest"
                       @onView="viewFile"

        >
            <FileCreate :id="createDiv"
                        :create-form-name="createFormName"
                        :create-div="createDiv"
                        :search-div="searchDiv"
                        :default-data="this.$parent.searchItems"
                        slot="createForm"
                        ref="createForm"
                        :input-items="createItems"
                        style="display: none"
                        create-url="/files/save"
                        form-name="lang.form.add_edit"

            />
        </c-search-form>
        <v-dialog v-model="requestInFileDlg" width="1200px">
            <v-card>
                <v-card-title>
                    <div class="headline dialog-header">
                        <v-btn @click="cancelRequestInFile" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Danh sách yêu cầu trong hồ sơ
                    </div>
                </v-card-title>
                <v-card-text>
                    <request-component @cancel="cancelRequestInFile"
                                       ref="document"/>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="waitingRequestDlg" width="1200px">
            <v-card>
                <v-card-title>
                    <div class="headline dialog-header">
                        <v-btn @click="cancelWaitingRequest" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Chọn yêu cầu gán vào hồ sơ
                    </div>
                </v-card-title>
                <v-card-text>
                    <waiting-request-component @cancel="cancelWaitingRequest"
                                               ref="waitingRequestDocument"/>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-container>
            <files-view id="viewFileDiv"
                        :search-div="searchDiv"
                        :default-data="this.file"
                        slot="createForm"
                        ref="viewForm"
                        style="display: none"
                        @cancel="onViewCancel"
            />
        </v-container>

    </div>
</template>

<script>
    import CSearchForm from "../../components/form/ManageForm";
    import axios from "axios";
    import FileCreate from "./FileCreate";
    import RequestComponent from "./components/RequestComponent";
    import WaitingRequestComponent from "./components/WaitingRequestComponent";
    import FileView from "../class/fileView";
    import FilesView from "./FileView";

    export default {
        name: 'request-management',
        components: {FilesView, FileView, FileCreate, CSearchForm, RequestComponent, WaitingRequestComponent},
        data: () => {
            return {
                formName: "lang.files.title",
                createFormName: "lang.files.titleCreate",
                searchDiv: "searchDivRequest",
                createDiv: "createDivRequest",
                searchItems: [],
                createItems: [
                    {
                        type: "text",
                        name: "fileCode",
                        label: "lang.files.fileCode",
                        validate: "required",
                        maxlength: '50',
                        placeHolder: "",
                        focus: true
                    },
                ],
                fields: [
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        value: 'ourFile',
                        text: 'lang.files.ourFile',
                        width: "15%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left",
                        event: "onView",
                    },
                    {
                        type: "select",
                        items: [],
                        itemText: "name",
                        itemValue: "id",
                        name: 'procedureId',
                        value: 'procedureId',
                        text: 'lang.files.procedureId',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        type: "select",
                        items: [],
                        itemText: "name",
                        itemValue: "id",
                        name: 'customerId',
                        value: 'customerId',
                        text: 'lang.files.customerId',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        type: "select",
                        items: [],
                        itemText: "name",
                        itemValue: "id",
                        name: 'manageId',
                        value: 'manageId',
                        text: 'lang.files.manageId',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'custom_action_list',
                        text: "lang.file.request",
                        width: "5%",
                        items: [
                            {
                                text: "lang.procedure.document",
                                icon: "folder_shared",
                                event: "onOpenRequestInFile",
                                color: "primary"
                            },
                            {
                                text: "lang.procedure.document",
                                icon: "add",
                                event: "onOpenWaitingRequest",
                                color: "primary"
                            }
                        ],

                    },


                    {
                        value: 'action',
                        text: "lang.common.actions",
                        width: "20%",
                        sortable: false,
                        compound: true,
                        headerStyle: "text-align:center"
                    }
                ],
                selectProc: null,
                feeDlg: false,
                requestInFileDlg: false,
                waitingRequestDlg: false,
                file: null
            }
        },
        created() {
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/user", {}).then(
                data => {
                    let item = this.createItems.filter(function (e) {
                        return e.name == "manageId";
                    });
                    if (item != undefined && item.length > 0) {
                        item[0].items = data.items;
                    }

                    let itemFields = this.fields.filter(function (e) {
                        return e.name == "manageId";
                    });
                    if (itemFields != undefined && itemFields.length > 0) {
                        itemFields[0].items = data.items;
                    }

                }
            )

            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/customer", {}).then(
                data => {
                    let item = this.createItems.filter(function (e) {
                        return e.name == "customerId";
                    });
                    if (item != undefined && item.length > 0) {
                        item[0].items = data.items;
                    }
                    let itemFields = this.fields.filter(function (e) {
                        return e.name == "customerId";
                    });
                    if (itemFields != undefined && itemFields.length > 0) {
                        itemFields[0].items = data.items;
                    }
                }
            )
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/procedure", {}).then(
                data => {
                    let item = this.createItems.filter(function (e) {
                        return e.name == "procedureId";
                    });
                    if (item != undefined && item.length > 0) {
                        item[0].items = data.items;
                    }
                    let itemFields = this.fields.filter(function (e) {
                        return e.name == "procedureId";
                    });
                    if (itemFields != undefined && itemFields.length > 0) {
                        itemFields[0].items = data.items;
                    }
                }
            )
        },

        methods: {
            onOpenRequestInFile(item) {
                this.requestInFileDlg = true;
                this.$refs.document.viewFilesRequest(item);
            },
            cancelRequestInFile() {
                this.requestInFileDlg = false;

            },
            onOpenWaitingRequest(item) {
                this.waitingRequestDlg = true;
                this.$refs.waitingRequestDocument.viewWaitingRequest(item);
            },
            cancelWaitingRequest() {
                this.waitingRequestDlg = false;
            },
            viewFile(file) {
                document.getElementById("searchDivRequest").style.display = "none";
                document.getElementById("viewFileDiv").style.display = "";

                this.file = file;
                this.$refs.viewForm.onView(file);
            },
            onViewCancel() {
                document.getElementById("searchDivRequest").style.display = "";
                document.getElementById("viewFileDiv").style.display = "none";
            }
        },
        watch: {
            requestInFileDlg: function (value) {
                if (value == false) {
                    this.$refs.document.cancelFilesRequest();
                }
            },
            waitingRequestDlg: function (value) {
                if (value == false) {
                    this.$refs.waitingRequestDocument.cancelWaitingRequest();
                }
            },
        },

        destroyed() {
        }
    }
</script>
